import { IEnvironment } from "./i-environment";

export const environment: IEnvironment = {
  gtm: {
    containerId: "GTM-MTQMLJ74"
  },
  api: {
    authentication: {
      useSSL: true,
      url: "api.qas.zaeper.com/auth"
    },
    receiverAuthentication: {
      useSSL: true,
      url: "api.qas.zaeper.com/receiver-auth"
    },
    receiver: {
      useSSL: true,
      url: "api.qas.zaeper.com/receiver"
    },
    infrastructure: {
      useSSL: true,
      url: "api.qas.zaeper.com/infrastructure"
    },
    application: {
      useSSL: true,
      url: "api.qas.zaeper.com/application"
    },
    user: {
      useSSL: true,
      url: "api.qas.zaeper.com/user"
    },
    company: {
      useSSL: true,
      url: "api.qas.zaeper.com/company"
    },
    license: {
      useSSL: true,
      url: "api.qas.zaeper.com/license"
    },
    billing: {
      useSSL: true,
      url: "api.qas.zaeper.com/billing"
    }
  },
  sites: {
    authentication: {
      useSSL: true,
      url: "auth.qas.zaeper.com"
    },
    developerDashboard: {
      useSSL: true,
      url: "developer.qas.zaeper.com"
    },
    vendorDashboard: {
      useSSL: true,
      url: "vendor.qas.zaeper.com"
    },
    businessPortalDashboard: {
      useSSL: true,
      url: "business-portal.qas.zaeper.com"
    }
  },
  websockets: {
    receiver: {
      useSSL: true,
      url: "api.qas.zaeper.com/ws/receiver"
    },
    receiverAuthentication: {
      useSSL: true,
      url: "api.qas.zaeper.com/ws/receiver-auth"
    }
  },
  applications: {
    previewer: {
      useSSL: true,
      url: "receiver-applications.qas.zaeper.com/apps/os/receiver-previewer-app/1.0.0/"
    }
  }
};
